module.exports = __webpack_public_path__ + "img/back_04.c12f29e3.png";